<template>
  <div class="body">
    <div>
      <img
        src="https://qishimai-1257428522.file.myqcloud.com/wechatapp/static/book/custommade_top.jpg"
        alt=""
      />
    </div>
    <div class="customize-box">
      <div class="black-color fs18 tac fw600" style="margin-bottom: 15px">
        免费定制行程
      </div>
      <div class="flex aic">
        <div class="fs14 fw500 black-color fw600">目的地</div>
        <div class="customize-input-wrap">
          <input placeholder="请填写目的地" type="text" v-model="place" />
        </div>
      </div>
      <div class="flex aic">
        <div class="fs14 fw500 black-color fw600">手机号</div>
        <div class="customize-input-wrap">
          <input
            placeholder="请填写手机号"
            type="number"
            v-model="phoneNumber"
          />
        </div>
      </div>
      <div class="flex aic">
        <div class="fs14 fw500 black-color fw600">验证码</div>
        <div class="flex jcsb aic customize-input-wrap">
          <input
            style="width: 120px"
            placeholder="请填写验证码"
            type="number"
            v-model="authCode"
          />
          <div class="main-color fs12 cp" @click="sendLoginAuthCode">
            {{ authCodeCountDown > 0 ? `${authCodeCountDown}s` : "获取验证码" }}
          </div>
        </div>
      </div>
      <button class="customize-button cp" @click="customizeSubmit">
        获取免费专属行程
      </button>
    </div>
    <div>
      <img
        src="https://qishimai-1257428522.file.myqcloud.com/wechatapp/static/custommade_image_advantage.png"
        alt=""
      />
    </div>
    <div>
      <img
        src="https://qishimai-1257428522.file.myqcloud.com/wechatapp/static/custommade_image_customizer.png"
        alt=""
      />
    </div>
    <div v-if="showSuccessModal" class="modal-mask">
      <div class="modal-box">
        <img src="https://qishimai-1257428522.file.myqcloud.com/website/new/customerservice_avatar.png" class="modal-avatar" />
        <div class="modal-title" style="margin-top: 50px">提交成功</div>
        <div class="modal-content" style="margin-top: 6px">
          我们已收到您的需求
        </div>
        <div class="modal-content">
          旅行顾问将在<span style="color: #0ba09a">24小时之内联系您</span>
        </div>
        <div class="modal-content" style="margin-bottom: 16px">
          请保持电话畅通
        </div>
        <div class="modal-btn cp" @click="showSuccessModal = false">好的</div>
      </div>
    </div>
    <div v-if="showToast" class="toast">
      <div>{{ toastContent }}</div>
    </div>
  </div>
</template>

<script>
import { get, post } from "@/utils/config.http";
import { api } from "@/utils/constVar";

export default {
  name: "CustomizeMobile",
  data() {
    return {
      phoneNumber: "",
      authCode: "",
      place: "",
      authCodeCountDown: 0,
      showSuccessModal: false,
      showToast: false,
      toastContent: "",
    };
  },
  //创建前设置
  beforeCreate() {
    document
      .querySelector("body")
      .setAttribute("style", "max-width: 100vw;min-width: 100vw;");
  },
  //销毁前清除
  beforeDestroy() {
    document.querySelector("body").removeAttribute("style");
  },
  methods: {
    sendLoginAuthCode() {
      if (this.authCodeCountDown > 0) {
        return;
      }
      if (!this.place) {
        this.toast("请输入目的地！");
        return;
      }
      if (this.phoneNumber) {
        const res = /^1\d{10}$/.test(this.phoneNumber);
        if (!res) {
          this.toast("请正确输入手机号！");
          return;
        }
        return get(api.getAuthCode, { phoneNumber: this.phoneNumber })
          .then((res) => {
            this.toast("发送成功！");
            this.authCodeCountDown = 60;
            this.authCodeCountDownHandle();
          })
          .catch((err) => {
            this.toast("发送验证码失败，请稍后重试");
          });
      } else {
        this.toast("请填写手机号！");
      }
    },
    authCodeCountDownHandle() {
      setTimeout(() => {
        this.authCodeCountDown = this.authCodeCountDown - 1;
        this.authCodeCountDownHandle();
      }, 1000);
    },
    customizeSubmit() {
      if (!this.place) {
        this.toast("请输入目的地！");
        return;
      }
      if (this.phoneNumber) {
        const res = /^1\d{10}$/.test(this.phoneNumber);
        if (!res) {
          this.toast("请重新确认手机号！");
          return;
        }
      } else {
        this.toast("请输入手机号！");
        return;
      }
      if (this.authCodeCountDown == 0) {
        this.toast("请获取验证码！");
        return;
      }
      if (this.authCode) {
        const res = /^[0-9]{6}/.test(this.authCode);
        if (!res) {
          this.toast("请输入正确的验证码！");
          return;
        }
      } else {
        this.toast("请输入验证码！");
        return;
      }
      return post(api.insertClue, {
        phoneNumber: this.phoneNumber,
        authCode: this.authCode,
        place: this.place,
        source: "官网",
      })
        .then((res) => {
          (this.phoneNumber = ""),
            (this.authCode = ""),
            (this.place = ""),
            (this.authCodeCountDown = 0),
            // this.toast('提交失败！');
            (this.showSuccessModal = true);
        })
        .catch((err) => {
          this.toast("提交失败！");
        });
    },
    toast(content) {
      this.toastContent = content;
      this.showToast = true;
      setTimeout(() => {
        this.showToast = false;
      }, 2000);
    },
  },
};
</script>

<style lang="less" scoped>
.body {
  width: 100%;
  background: #1fb399;
  img {
    width: 100%;
  }
  .customize-box {
    width: 79vw;
    padding: 28px 18px 28px 38px;
    box-shadow: 0px 3px 14px rgba(165, 165, 165, 0.24);
    border-radius: 11px;
    background-color: #fff;
    margin: 0px auto 20px;
  }
  .customize-input-wrap {
    height: 36px;
    width: 184px;
    margin: 8px 0 6px 20px;
    padding: 0 10px;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
  }
  input {
    height: 36px;
    width: 184px;
  }
  .button {
    width: 186px;
    height: 28px;
    font-size: 11px;
    background: #ffffff;
    color: #0ba09a;
    border-radius: 5px;
    // margin: 0 10px;
    line-height: 2.3;
    margin: 20px 0;
  }
  .customize-button {
    margin-top: 30px;
    width: 272.5px;
    height: 33.5px;
    font-size: 14.5px;
    background: #0ba09a;
    border-radius: 8px;
    color: #ffffff;
  }
  .toast {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/CustomizeMobile.vue